import { OrderFormBank, OrderFormContact, OrderFormAdditional, OrderFormMisc, OrderFormPorting } from './index';
var OrderFormData = /*@__PURE__*/ (function () {
    function OrderFormData() {
        this.bank = new OrderFormBank();
        this.persdaten = new OrderFormContact();
        this.additional = new OrderFormAdditional();
        this.misc = new OrderFormMisc();
        this.porting = new OrderFormPorting();
        this.portings = [];
    }
    OrderFormData.prototype.getBank = function () {
        return this.bank;
    };
    OrderFormData.prototype.setBank = function (bank) {
        this.bank = bank;
        return this;
    };
    OrderFormData.prototype.getContact = function () {
        return this.persdaten;
    };
    OrderFormData.prototype.setContact = function (contact) {
        this.persdaten = contact;
        return this;
    };
    OrderFormData.prototype.getAdditional = function () {
        return this.additional;
    };
    OrderFormData.prototype.setAdditional = function (additional) {
        this.additional = additional;
        return this;
    };
    OrderFormData.prototype.getMisc = function () {
        return this.misc;
    };
    OrderFormData.prototype.setMisc = function (misc) {
        this.misc = misc;
        return this;
    };
    OrderFormData.prototype.getPorting = function () {
        return this.porting;
    };
    OrderFormData.prototype.setPorting = function (porting) {
        this.porting = porting;
        return this;
    };
    return OrderFormData;
}());
export { OrderFormData };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-data.ts
// module id = null
// module chunks = 